module.exports = __webpack_public_path__ + "img/office-building.8d56fa5b.png";